import React, { useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { fetchDataSearch } from "../service/api";
import { 
  setCountryList,
  setCurriculumList,
  setRatingList,
  setSchoolgradeList,
  setSchoolyearList,
  setLoader,
  setAges
} from '@/redux/dataSlice';
import LoadingSpinner from '@/components/LoadingSpinner';

const useSearchTitle = () => {
  const dispatch = useDispatch();
  const { countryList, curriculumList, ratingList,schoolgradeList,schoolyearList,loader } = useSelector((state: any) => state.data);

  const fetchDataAsync = async () => {
    dispatch(setLoader(true));
    try {
      const response = await fetchDataSearch();

      const data = response?.data;

      const countries = data?.country;
      const curriculums = data?.curriculum;
      const ratings = data?.rating;
      const schoolGrades = data?.schoolgrade;
      const schoolYears = data?.schoolyear;
      const ages = data?.age;

      if (!data) {
        dispatch(setLoader(true));
        dispatch(setCountryList(null));
        dispatch(setCurriculumList(null));
        dispatch(setRatingList(null));
        dispatch(setSchoolgradeList(null));
        dispatch(setSchoolyearList(null));
        dispatch(setAges(null));
      } else {
        dispatch(setCountryList(countries));
        dispatch(setCurriculumList(curriculums));
        dispatch(setRatingList(ratings));
        dispatch(setSchoolgradeList(schoolGrades));
        dispatch(setSchoolyearList(schoolYears));
        dispatch(setAges(ages));
        
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }finally {
      dispatch(setLoader(false));
    }
  };

  useEffect(() => {
    if (!countryList || !curriculumList || !ratingList || !schoolgradeList || !schoolyearList) {
      fetchDataAsync();
    }
  }, [countryList, curriculumList, ratingList,schoolgradeList,schoolyearList, dispatch]);
  return loader ?<LoadingSpinner />: null;
}

export default useSearchTitle;
